import { ResponsiveText } from '@farmersdog/corgi-legacy';
import { Mask } from '@farmersdog/corgi-x';

import styles from './PlanStep.css';

import type { ReactNode } from 'react';

export interface PlanStepProps {
  step: number;
  title: ReactNode;
  description: ReactNode;
}

export function PlanStep({ step, title, description }: PlanStepProps) {
  return (
    <li className={styles.item}>
      <Mask shape="circle" size="sm">
        <ResponsiveText
          variant="heading-4"
          color="white"
          as="span"
          className={styles.step}
        >
          {step}
        </ResponsiveText>
      </Mask>
      <ResponsiveText
        className={styles.title}
        variant="heading-3"
        as="h3"
        color="kale-3"
      >
        {title}
      </ResponsiveText>
      <ResponsiveText
        className={styles.description}
        variant="article-2"
        as="p"
        color="charcoal-3"
      >
        {description}
      </ResponsiveText>
    </li>
  );
}
